import Recur from "simple-recur";

class DatePeriod {

    static getMeasure(periodicity) {
        if (periodicity === 'A') {
            return 'years';
        }
        if (periodicity === 'M') {
            return 'months';
        }
        if (periodicity === 'Q') {
            return 'months';
        }

        return 'days';
    }

    static getJump(periodicity) {
        if (periodicity === 'Q') {
            return 3;
        }

        return 1;
    }

    static range(begin, end, interval) {
        const recur = new Recur({
            start: begin,
            measure: DatePeriod.getMeasure(interval),
        });

        let dates = [];

        let i = 0;
        const jump = DatePeriod.getJump(interval);

        dates.push(recur.nextAt(i).format('YYYY-MM-DD'));

        while (dates[dates.length - 1] + '-01' < end) {
            i += jump;
            dates.push(recur.nextAt(i).format('YYYY-MM-DD'));
        }

        return dates;
    }

    static grow(begin, interval, grow) {
        const recur = new Recur({
            start: begin,
            measure: DatePeriod.getMeasure(interval),
        });

        let dates = [];

        let i = 0;
        const jump = DatePeriod.getJump(interval);

        while (i < grow) {
            i++;
            dates.push(recur.nextAt(i * jump).format('YYYY-MM-DD'));
        }

        return dates;
    }

}

export default DatePeriod;
